import React from 'react';
import PropTypes from 'prop-types';

import { DODGER_BLUE } from '@app/constant/colors';

const QRScanner = ({ color }) => (
  <svg viewBox="0 0 64 64" fill="none">
    <circle cx="32" cy="32" r="31" stroke={color} strokeWidth="2" />
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="2"
      y="2"
      width="60"
      height="60"
    >
      <circle cx="32" cy="32" r="30" fill="#C4C4C4" />
    </mask>
    <g mask="url(#mask0)">
      <g clipPath="url(#clip0)">
        <path
          d="M26.88 16H37.12C39.4147 16 41.0747 16.0008 42.3794 16.1092C43.6722 16.2165 44.5264 16.4243 45.2268 16.7881C46.5053 17.4522 47.5478 18.4947 48.2119 19.7732C48.5757 20.4736 48.7835 21.3278 48.8908 22.6206C48.9992 23.9253 49 25.5853 49 27.88V69.2782C49 70.6928 48.9992 71.6926 48.9343 72.4736C48.8705 73.2425 48.7497 73.7093 48.5599 74.0747C48.189 74.7887 47.6069 75.3708 46.8929 75.7417C46.5274 75.9316 46.0607 76.0523 45.2917 76.1162C44.5108 76.181 43.511 76.1818 42.0964 76.1818H21.9036C20.489 76.1818 19.4892 76.181 18.7083 76.1162C17.9393 76.0523 17.4726 75.9316 17.1071 75.7417C16.3931 75.3708 15.811 74.7887 15.4401 74.0747C15.2503 73.7093 15.1295 73.2425 15.0657 72.4736C15.0008 71.6926 15 70.6928 15 69.2782V27.88C15 25.5853 15.0008 23.9253 15.1092 22.6206C15.2165 21.3278 15.4243 20.4736 15.7881 19.7732C16.4522 18.4947 17.4947 17.4522 18.7732 16.7881C19.4736 16.4243 20.3278 16.2165 21.6206 16.1092C22.9253 16.0008 24.5853 16 26.88 16Z"
          stroke={color}
          strokeWidth="2"
        />
        <path
          d="M24 17H40L38.4858 19.2713C38.1823 19.7266 37.6714 20 37.1242 20H26.8758C26.3286 20 25.8177 19.7266 25.5142 19.2713L24 17Z"
          fill={color}
        />
      </g>
      <path
        d="M29 30H25C23.3431 30 22 31.3431 22 33V45M35.5931 30H39C40.6569 30 42 31.3431 42 33V36.4069M42 34.7042V47C42 48.6569 40.6569 50 39 50H35.5931M29 50H25C23.3431 50 22 48.6569 22 47V43"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M35 27V53"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <rect x="25.5" y="33.5" width="5" height="5" stroke={color} />
      <mask id="path-12-inside-1" fill="white">
        <rect x="27" y="35" width="2" height="2" rx="0.5" />
      </mask>
      <rect
        x="27"
        y="35"
        width="2"
        height="2"
        rx="0.5"
        stroke={color}
        strokeWidth="2"
        mask="url(#path-12-inside-1)"
      />
      <rect x="25.5" y="41.5" width="5" height="5" stroke={color} />
      <mask id="path-14-inside-2" fill="white">
        <rect x="27" y="43" width="2" height="2" rx="0.5" />
      </mask>
      <rect
        x="27"
        y="43"
        width="2"
        height="2"
        rx="0.5"
        stroke={color}
        strokeWidth="2"
        mask="url(#path-14-inside-2)"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect x="14" y="15" width="36" height="62.1818" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

QRScanner.propTypes = {
  color: PropTypes.string,
};

QRScanner.defaultProps = {
  color: DODGER_BLUE,
};

export default QRScanner;
